import { PaginationOptionsDto } from "@/models/api";
import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { LadiesSearchReqParams } from "../helpers";
import { LadySearchListResponseDto } from "../models";

export abstract class SearchLadiesApi {
  static get = async (_params: LadiesSearchReqParams) => {
    const params = new URLSearchParams(_params as Record<string, string>)
      .toString()
      .replace(/&/g, ",");

    const query = {
      requestType: "ladyProfileList",
      contentPage: "search",
      params: params ? `?${params}` : "",
    };

    return withSchemaValidation(
      GbApiRequestService.get("userApi", { params: query }),
      LadySearchListResponseDto,
    );
  };

  static getPaginationOptions = async (_params: LadiesSearchReqParams) => {
    const params = new URLSearchParams(_params as Record<string, string>)
      .toString()
      .replace(/&/g, ",");

    const query = {
      requestType: "paging",
      contentPage: "search",
      params: params ? `?${params}` : "",
    };

    return withSchemaValidation(
      GbApiRequestService.get("userApi", { params: query }),
      PaginationOptionsDto,
    );
  };
}
